

export default angular.module("mars.vet.dnareports.controllers.print",[]).controller('PrintReportController', function($scope,$rootScope, EntryIDService, EntryService, BreedListService, ImageService,DisorderDataService,UtilityService, TranslationService,$timeout,$window,reportdata) {

	
    let resultString = reportdata.resultString;
    let sampleDetails = reportdata.sampleDetails;
    
	$scope.getVersionFeature = UtilityService.getVersionFeature;
	
	ImageService.getImageUrl('2wmltkOoi4woMqyqeC246q').then(function(response) {
	        $scope.downloadImageUrl = response.data.fields.file.url;
	});

    ImageService.getImageUrl('5ZHbgmta1228QASi4m0K0M').then(function(response) {
        $scope.wisdomPanelLogoUrl = response.data.fields.file.url;
    });
    
    
    
    $scope.pbdd = false;
    var resultPbDdBreed = resultString.resultPbDdBreed;
    if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
    	$scope.pbdd = true;
    }
    $scope.exceptionLetter = false;
    if (resultString.event[0] !== null && resultString.event[0] !== undefined &&
        resultString.event[0]['letterflag'] != null && resultString.event[0]['letterflag'] != 'undefined') {
    	$scope.exceptionLetter = true;;
    }
	
    $scope.atRiskData = DisorderDataService.getAtRiskData();
    $scope.carrierData = DisorderDataService.getCarrierData();
    $scope.noCallData = DisorderDataService.getNoCallData();
    $scope.allClearData = DisorderDataService.getAllClearData();
	
	$scope.printreport = function () {
		window.print();
	};
	
	
	/*$timeout(function() {
	$(document).ready(function(){
  		window.print();
  	});  
	}, 2500);*/
	
	
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/print.controller.js